module.exports = __webpack_public_path__ + "img/ico_feed_watchearn@3x.540ff6fd.png";